import React from "react";
import { Link } from "react-router-dom";

function formatCurrency(value) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export default function ProductCard({ product, onAddToCart }) {
  const image = product?.featured_image || product?.image || "";
  const hasDiscount =
    Number(product?.original_price || 0) > Number(product?.price || 0);

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
      <Link to={`/product/${product?.slug}`} className="block">
        <div className="aspect-[4/3] overflow-hidden bg-gray-100">
          {image ? (
            <img
              src={image}
              alt={product?.name}
              className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-sm text-gray-400">
              Tidak ada gambar
            </div>
          )}
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-start justify-between gap-3">
          <span className="rounded-full bg-orange-50 px-2.5 py-1 text-xs font-medium text-orange-700">
            {product?.category_name || "Produk IoT"}
          </span>
          <span className={`text-xs font-medium ${Number(product?.stock) > 0 ? "text-emerald-600" : "text-red-600"}`}>
            {Number(product?.stock) > 0 ? `Stok ${product?.stock}` : "Stok habis"}
          </span>
        </div>

        <Link to={`/product/${product?.slug}`}>
          <h3 className="line-clamp-2 text-lg font-semibold text-gray-900 transition group-hover:text-orange-600">
            {product?.name}
          </h3>
        </Link>

        <p className="mt-2 line-clamp-3 text-sm leading-6 text-gray-600">
          {product?.short_description || product?.description || "Belum ada deskripsi."}
        </p>

        <div className="mt-4 flex items-center gap-2 text-xs text-gray-500">
          <span>⭐ {Number(product?.rating || 0).toFixed(1)}</span>
          <span>•</span>
          <span>Terjual {Number(product?.sold_count || 0)}</span>
        </div>

        <div className="mt-4">
          {hasDiscount && (
            <p className="text-sm text-gray-400 line-through">
              {formatCurrency(product?.original_price)}
            </p>
          )}
          <p className="text-xl font-bold text-orange-600">
            {formatCurrency(product?.price)}
          </p>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-2">
          <Link
            to={`/product/${product?.slug}`}
            className="inline-flex items-center justify-center rounded-xl border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:border-orange-500 hover:text-orange-600"
          >
            Detail
          </Link>
          <button
            type="button"
            onClick={() => onAddToCart?.(product)}
            className="inline-flex items-center justify-center rounded-xl bg-orange-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-orange-700"
          >
            Tambah
          </button>
        </div>
      </div>
    </article>
  );
}
